if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const variantInput = this.form.querySelector('[name=id]');
        if (!variantInput || variantInput.disabled) return;

        const item = { id: Number(variantInput.value), quantity: 1 };

        const sellingPlanInput = this.form.querySelector('[name=selling_plan]');
        if (sellingPlanInput && sellingPlanInput.value) {
          item.selling_plan = Number(sellingPlanInput.value);
        }

        Robin.addItems([item], true);
      }
    }
  );
}
